import leadsCollection from "./leads.js";
import companiesCollection from "./companies.js";
import prospectsCollection from "./prospects.js";
import emailsCollection from "./emails.js";
import suppressionsCollection from "./suppressions.js";
import agentRunsCollection from "./agent_runs.js";
import modelSpendCollection from "./model_spend.js";
import notificationsCollection from "./notifications.js";
import emailThreadsCollection from "./email_threads.js";
import emailMessagesCollection from "./email_messages.js";
import emailSenderRulesCollection from "./email_sender_rules.js";
import mailboxesCollection from "./mailboxes.js";
import mailboxFoldersCollection from "./mailbox_folders.js";
import emailTemplatesCollection from "./email_templates.js";
import activitiesCollection from "./activities.js";
import tasksCollection from "./tasks.js";
import visibilityChecksCollection from "./visibility_checks.js";
import citationTargetsCollection from "./citation_targets.js";
import usersCollection from "./users.js";

export const collections = [
    leadsCollection,
    companiesCollection,
    prospectsCollection,
    emailsCollection,
    suppressionsCollection,
    agentRunsCollection,
    modelSpendCollection,
    notificationsCollection,
    mailboxesCollection,
    mailboxFoldersCollection,
    emailThreadsCollection,
    emailMessagesCollection,
    emailSenderRulesCollection,
    emailTemplatesCollection,
    activitiesCollection,
    tasksCollection,
    visibilityChecksCollection,
    citationTargetsCollection,
    usersCollection,
];
